import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export default function Loading() {
  return (
    <div className="card rounded-sm mt-md">
      <Skeleton height={30} />
      <div className="card-body">
        <h2 className="card-title"><Skeleton width={150} /></h2>
        <p className="card-text"><Skeleton count={3} /></p>
      </div>
    </div>
  );
}
